interface EmailSubscriptionFeatureToggles {
  journalFooterForm: boolean
  journalPopUp: boolean
  journalPopUpDelay: number
}

interface SmartBannerFeatureToggles {
  redisplayIntervalJournal: number
}

export interface FeatureTogglesSerializerOutput {
  emailSubscription?: EmailSubscriptionFeatureToggles
  smartBanner?: SmartBannerFeatureToggles
}

export const FEATURE_TOGGLES_PRESET: FeatureTogglesSerializerOutput = {
  emailSubscription: {
    journalFooterForm: false,
    journalPopUp: false,
    journalPopUpDelay: 30,
  },
  smartBanner: {
    redisplayIntervalJournal: 30,
  },
}

interface FeatureTogglesSerializerInput {
  EmailSubscription: {
    JournalFooterForm: boolean
    JournalPopUp: boolean
    JournalPopUpDelay: number
  }
  SmartBanner?: {
    redisplay_interval_journal: number
  }
}

export function FeatureTogglesSerializer({
  EmailSubscription,
  SmartBanner,
}: FeatureTogglesSerializerInput): FeatureTogglesSerializerOutput {
  return {
    emailSubscription: {
      journalFooterForm: EmailSubscription.JournalFooterForm,
      journalPopUp: EmailSubscription.JournalPopUp,
      journalPopUpDelay: EmailSubscription.JournalPopUpDelay,
    },
    smartBanner: {
      redisplayIntervalJournal: SmartBanner?.redisplay_interval_journal || 30,
    },
  }
}
